<script setup lang="ts">
import { redirectToFilterPage } from '@/composables/accosbar.helpers'
import { CULTURE, getTotalOccupancyAmount, toSmallStringDate } from '@/composables/helpers'
import t from '@/i18n/translations'
import { popupVisible, rooms } from '@/store/accosbar.store'
import InputText from 'primevue/inputtext'
import { computed } from 'vue'

const formattedDateString = computed(() => {
  return toSmallStringDate()
})

const getOccupancyCount = computed(() => {
  const x = getTotalOccupancyAmount(rooms.value)
  if (x != null) {
    var adults = x.adults
    var childrens = x.children
    return adults + childrens
  }
})
</script>

<template>
  <div :class="'accosbar-mini fixed bottom-0 w-full'">
    <div class="flex flex-row items-center justify-center gap-2">
      <div class="relative h-10 w-2/3">
        <InputGroup class="relative">
          <InputText
            v-model="formattedDateString"
            :readonly="true"
            :fluid="true"
            :placeholder="t(`${CULTURE}.accosbar.date`)"
            @click="popupVisible = true"
            class="cursor-pointer pr-4 text-xs"
          />
          <InputGroupAddon>
            <Button
              class="absolute right-2 top-0 flex h-full w-14 border-l border-black pl-2 text-black"
              severity="secondary"
              variant="text"
              @click="popupVisible = true"
            >
              <div class="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                  />
                </svg>
              </div>
              <span>
                {{ getOccupancyCount }}
              </span>
            </Button>
          </InputGroupAddon>
        </InputGroup>
      </div>
      <button type="submit" class="myEnquiryButton w-1/3 rounded py-2 md:w-fit" @click="redirectToFilterPage()">
        {{ t(`${CULTURE}.accosbar.search`) }}
      </button>
    </div>
  </div>
</template>
